import waysOfCommunication_plPL from "../../translations/pl_PL/blog/waysOfCommunication.json";
import { PUT_DATA_BLOG } from '../Blog/action';

function knowladgeWaysOfCommunicationReducer(
  state = waysOfCommunication_plPL,
  action
) {
  switch (action.type) {
    case PUT_DATA_BLOG:
      {
        if (action.meta === "waysOfCommunication") {
          return action.payload;
        } else { 
          return state }
      }

    default:
      return state;
  }
}

export default knowladgeWaysOfCommunicationReducer;
